import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';

const TextBlock = styled('div', { padding: '10px', margin: '4px' });
const ButtonBlock = styled('div', { padding: '5px', margin: '4px' });
const ReturnLink = styled(Link, { padding: '5px', margin: '4px' });
const ReturnButton = styled(Button, {
    '&.abyss-button-root': {
        backgroundColor: '$interactiveNav',
        borderColor: '$interactiveNav',
        color: '$textOnDark',
        '&:hover': {
            backgroundColor: '$surfaceHeroHover',
            borderColor: '$surfaceHeroHover',
            color: '$textPrimary',
            boxShadow: '1px 1px 1px #dadbdc',
        },
        '&:disabled': {
            backgroundColor: '$surfaceDisabled',
            borderColor: '$surfaceDisabled',
            color: '$textSecondary',
            boxShadow: '1px 1px 1px #dadbdc',
        },
        '&:focus': { outline: '2px solid $interactiveNav' },
    },
});

export const LoggedOut = () => {

    const { t } = useTranslation();

    return (
        <div>
            <Layout.Stack alignLayout="center">
                <TextBlock>
                    <Text>
                        {t('loggedOutMsg')}
                    </Text>
                </TextBlock>
                <ButtonBlock>
                    <ReturnLink to="/login" tabIndex={-1}>
                        <ReturnButton
                            id="returnBtn"
                            size="$lg"
                        >{t('return')}</ReturnButton>
                    </ReturnLink>
                </ButtonBlock>
            </Layout.Stack>
        </div>
    );
}